<template>
    <header :class="['header', { shrink: isShrink }]">
        <div class="bar inner">
            <div class="logo">
                <a href="/"><img src="@/assets/logo_main.svg" alt=""></a>
            </div>
            <div class="head_menu">
                <!-- PC 메뉴 -->
                <div class="pc_menu">
                    <HeaderMenu />
                </div>    
            </div>
            <!-- 모바일 메뉴 버튼 -->
            <div id="nav-icon" 
                :class="{ open: menuOpen }"
                @click="toggleMenu">
                <span></span><span></span><span></span><span></span>
            </div>

            <!-- 모바일 메뉴 -->
            <div class="mob_menu" :class="{ active: menuOpen }">
                <HeaderMenu />
            </div>
        </div>
    </header>
</template>

<script>
    import HeaderMenu from './HeaderMenu.vue';

    export default {
        name: "TheHeader",
        components: { HeaderMenu },

        data() {
            return {
                menuOpen: false
            }
        },
        methods: {
            toggleMenu() {
                this.menuOpen = !this.menuOpen;
            }
        }
    };
</script>

<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'

    const isShrink = ref(false)

    const handleScroll = () => {
    isShrink.value = window.scrollY > 40
    }

    onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    })

    onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
    })
</script>